import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n          Hours of Work\n        ", -1);
const _hoisted_4 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_5 = { class: "col-span-6" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", {
    for: "hoursPerWeek",
    class: "block text-sm font-medium text-gray-700"
}, "How many hours will be worked in a typical week? *", -1);
const _hoisted_7 = ["value", "disabled"];
const _hoisted_8 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_9 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_10 = { class: "col-span-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", {
    for: "weeksPerYear",
    class: "block text-sm font-medium text-gray-700"
}, "How many weeks will be worked in a typical year? *", -1);
const _hoisted_12 = ["value", "disabled"];
const _hoisted_13 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_14 = {
    key: 0,
    class: "text-sm font-medium text-red-700 mt-2"
};
const _hoisted_15 = {
    key: 1,
    class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4"
};
const _hoisted_16 = { class: "col-span-6" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("label", {
    for: "paidHoliday",
    class: "block text-sm font-medium text-gray-70"
}, "This employee is to be paid holidays instead of taking\n                them:", -1);
const _hoisted_18 = ["value"];
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("option", { value: "yes" }, "Yes", -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("option", { value: "no" }, "No", -1);
const _hoisted_21 = {
    key: 2,
    class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4"
};
const _hoisted_22 = { class: "col-span-6" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("label", {
    for: "additional-information",
    class: "block text-sm font-medium text-gray-700"
}, "Justification:", -1);
const _hoisted_24 = ["value"];
const _hoisted_25 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_26 = { class: "col-span-6" };
const _hoisted_27 = { class: "text-base font-medium text-gray-900" };
const _hoisted_28 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_29 = { class: "mt-4 space-y-4" };
const _hoisted_30 = { class: "flex items-start" };
const _hoisted_31 = { class: "h-5 flex items-center" };
const _hoisted_32 = ["disabled", "checked"];
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "shiftPattern",
        class: "font-medium text-gray-700"
    }, "Call Out Rota (Dealing with Emergencies)")
], -1);
const _hoisted_34 = { class: "flex items-start" };
const _hoisted_35 = { class: "h-5 flex items-center" };
const _hoisted_36 = ["disabled", "checked"];
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "shiftPattern",
        class: "font-medium text-gray-700"
    }, "Complex Work Pattern")
], -1);
const _hoisted_38 = { class: "flex items-start" };
const _hoisted_39 = { class: "h-5 flex items-center" };
const _hoisted_40 = ["disabled", "checked"];
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "shiftPattern",
        class: "font-medium text-gray-700"
    }, "Evenings and Weekends")
], -1);
const _hoisted_42 = { class: "flex items-start" };
const _hoisted_43 = { class: "h-5 flex items-center" };
const _hoisted_44 = ["disabled", "checked"];
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "shiftPattern",
        class: "font-medium text-gray-700"
    }, "Part Time")
], -1);
const _hoisted_46 = { class: "flex items-start" };
const _hoisted_47 = { class: "h-5 flex items-center" };
const _hoisted_48 = ["disabled", "checked"];
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "shiftPattern",
        class: "font-medium text-gray-700"
    }, "Standard Hours (e.g. 9am - 5pm)")
], -1);
const _hoisted_50 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_51 = { class: "col-span-6" };
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("label", {
    for: "additional-information",
    class: "block text-sm font-medium text-gray-700"
}, "Please detail below any additional information relating to the\n                shift pattern:", -1);
const _hoisted_53 = ["value", "disabled"];
const _hoisted_54 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_55 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "hours-per-week-input",
                                value: _ctx.formData.hoursPerWeek,
                                type: "number",
                                min: "0",
                                name: "hoursPerWeek",
                                autocomplete: "name",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                        'error-border': _ctx.v$.formData.hoursPerWeek.$error,
                                        'border-red-500': _ctx.v$.formData.hoursPerWeek.$error,
                                    }]),
                                disabled: _ctx.showApprovalSteps,
                                onInput: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.hoursPerWeek.$touch()))
                            }, null, 42, _hoisted_7),
                            _createTextVNode(),
                            (_ctx.v$.formData.hoursPerWeek.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "\n                * " + _toDisplayString(_ctx.v$.formData.hoursPerWeek.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "weeks-per-year-input",
                                value: _ctx.formData.weeksPerYear,
                                type: "number",
                                min: "0",
                                name: "weeksPerYear",
                                autocomplete: "email",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                        'error-border': _ctx.v$.formData.weeksPerYear.$error,
                                        'border-red-500': _ctx.v$.formData.weeksPerYear.$error,
                                    }]),
                                disabled: _ctx.showApprovalSteps,
                                onInput: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.weeksPerYear.$touch()))
                            }, null, 42, _hoisted_12),
                            _createTextVNode(),
                            (_ctx.v$.formData.weeksPerYear.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "\n                * " + _toDisplayString(_ctx.v$.formData.weeksPerYear.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createTextVNode(),
                    (parseInt(_ctx.formData.weeksPerYear) < 52)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, "\n            In all cases it is expected that the employee will receive an annual\n            leave entitlement to be taken as part of their working time as there\n            should be no roles in EQUANS where annual leave is not permitted. If\n            this is not the case, please tick the box below and provide the\n            justification why the employee should receive a payment in lieu of\n            holidays instead of being allowed to take annual leave.\n          "))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    (parseInt(_ctx.formData.weeksPerYear) < 52)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _hoisted_17,
                                _createTextVNode(),
                                _createElementVNode("select", {
                                    id: "paidHoliday",
                                    name: "paidHoliday",
                                    autocomplete: "paidHoliday",
                                    value: _ctx.formData.paidHoliday,
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    onChange: _cache[4] || (_cache[4] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                                }, [
                                    _hoisted_19,
                                    _createTextVNode(),
                                    _hoisted_20
                                ], 40, _hoisted_18)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    (parseInt(_ctx.formData.weeksPerYear) < 52)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _hoisted_23,
                                _createTextVNode(),
                                _createElementVNode("textarea", {
                                    id: "justification-input",
                                    value: _ctx.formData.justification,
                                    type: "text",
                                    name: "justification",
                                    autocomplete: "email",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    onInput: _cache[5] || (_cache[5] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                                }, null, 40, _hoisted_24)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("fieldset", null, [
                                _createElementVNode("legend", _hoisted_27, "\n                  What is the anticipated shift pattern for this role?\n                  " + _toDisplayString(_ctx.isZeroHourContract ? "" : "*"), 1),
                                _createTextVNode(),
                                (_ctx.v$.formData.shiftPattern.$errors.length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, "\n                  * " + _toDisplayString(_ctx.v$.formData.shiftPattern.$errors[0].$message), 1))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("div", _hoisted_31, [
                                            _createElementVNode("input", {
                                                id: "checkbox-shift-pattern-call-out-rotor",
                                                name: "shiftPattern",
                                                type: "checkbox",
                                                value: "Call Out Rotor (Dealing with Emergencies)",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.shiftPattern.includes('Call Out Rotor (Dealing with Emergencies)'),
                                                onChange: _cache[6] || (_cache[6] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                                onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.shiftPattern.$touch()))
                                            }, null, 42, _hoisted_32)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_33
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("input", {
                                                id: "checkbox-shift-pattern-complex",
                                                name: "shiftPattern",
                                                type: "checkbox",
                                                value: "Complex Work Pattern",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.shiftPattern.includes('Complex Work Pattern'),
                                                onChange: _cache[8] || (_cache[8] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                                onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.shiftPattern.$touch()))
                                            }, null, 42, _hoisted_36)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_37
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_38, [
                                        _createElementVNode("div", _hoisted_39, [
                                            _createElementVNode("input", {
                                                id: "checkbox-shift-pattern-evenings-and-weekends",
                                                name: "shiftPattern",
                                                type: "checkbox",
                                                value: "Evenings and Weekends",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.shiftPattern.includes('Evenings and Weekends'),
                                                onChange: _cache[10] || (_cache[10] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                                onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.formData.shiftPattern.$touch()))
                                            }, null, 42, _hoisted_40)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_41
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_42, [
                                        _createElementVNode("div", _hoisted_43, [
                                            _createElementVNode("input", {
                                                id: "checkbox-shift-pattern-part-time",
                                                name: "shiftPattern",
                                                type: "checkbox",
                                                value: "Part Time",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.shiftPattern.includes('Part Time'),
                                                onChange: _cache[12] || (_cache[12] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                                onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.formData.shiftPattern.$touch()))
                                            }, null, 42, _hoisted_44)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_45
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("div", _hoisted_47, [
                                            _createElementVNode("input", {
                                                id: "checkbox-shift-pattern-standard",
                                                name: "shiftPattern",
                                                type: "checkbox",
                                                value: "Standard Hours (e.g. 9am - 5pm)",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.shiftPattern.includes('Standard Hours (e.g. 9am - 5pm)'),
                                                onChange: _cache[14] || (_cache[14] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                                onBlur: _cache[15] || (_cache[15] = ($event) => (_ctx.v$.formData.shiftPattern.$touch()))
                                            }, null, 42, _hoisted_48)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_49
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createTextVNode(),
                            _createElementVNode("textarea", {
                                id: "additional-information-input",
                                value: _ctx.formData.additionalInformation,
                                type: "text",
                                name: "additionalInformation",
                                autocomplete: "email",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                    }]),
                                disabled: _ctx.showApprovalSteps,
                                onInput: _cache[16] || (_cache[16] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                            }, null, 42, _hoisted_53)
                        ])
                    ])
                ])
            ]),
            _createTextVNode(),
            (!_ctx.showApprovalSteps)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _createElementVNode("button", {
                        class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                        onClick: _cache[17] || (_cache[17] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleResetForm && _ctx.handleResetForm(...args)), ["prevent"]))
                    }, "\n          Reset Form\n        "),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[18] || (_cache[18] =
                            //@ts-ignore
                            (...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
                    }, "\n          Next\n        ", 8, _hoisted_55)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
